'use strict';

import { clearProgressCookies, readProgressFromCookies, writeProgressToCookies } from './studyBuilderProgressCookie.js';

const STORAGE_KEY = 'studyBuilderGuestSessionV1';

/**
 * Persists study builder progress (sessionStorage + chunked cookies) for guests across refresh and login redirect.
 * @returns {Record<string, unknown>|null}
 */
export function readStudyBuilderGuestSession() {
	try {
		const raw = sessionStorage.getItem(STORAGE_KEY);
		if (raw) {
			const o = JSON.parse(raw);
			if (o && typeof o === 'object') return o;
		}
	} catch {
		// fall through to cookie
	}
	try {
		const fromCookie = readProgressFromCookies();
		if (fromCookie && typeof fromCookie === 'object') {
			try {
				sessionStorage.setItem(STORAGE_KEY, JSON.stringify(fromCookie));
			} catch {
				// ignore
			}
			return fromCookie;
		}
	} catch {
		// ignore
	}
	return null;
}

/** @param {Record<string, unknown>} partial */
export function writeStudyBuilderGuestSession(partial) {
	try {
		let prev = {};
		try {
			const raw = sessionStorage.getItem(STORAGE_KEY);
			if (raw) prev = JSON.parse(raw) || {};
		} catch {
			prev = {};
		}
		const next = { ...prev, ...partial, v: 1 };
		sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
		writeProgressToCookies(next);
	} catch {
		// ignore quota / private mode
	}
}

/** @param {{ lineItems?: unknown[], sampleInfo?: Record<string, unknown>, contactInfo?: Record<string, unknown> }} quote */
export function mergeQuoteIntoGuestSession(quote) {
	writeStudyBuilderGuestSession({ quote });
}

export function clearStudyBuilderGuestSession() {
	try {
		sessionStorage.removeItem(STORAGE_KEY);
		clearProgressCookies();
	} catch {
		// ignore
	}
}
